/* ==========================================================================
   Landing — Producto destacado
   Selector compra única / suscripción, variantes, cantidad, frecuencia,
   barra de envío gratis (umbral global theme.freeShippingThreshold) y
   animaciones de entrada.

   Equivalencia: 500 g = 60 cafés.
   ========================================================================== */
(function () {
  'use strict';

  // Lo cargan varias secciones (producto destacado, tarjetas): inicializar una sola vez
  if (window.EbocaPurchase) return;

  var CAFES_PER_500G = 60;
  var NUMBERS = ['cero', 'una', 'dos', 'tres', 'cuatro', 'cinco', 'seis', 'siete', 'ocho', 'nueve', 'diez'];
  var MONTHS_TEXT = { 1: 'cada mes', 2: 'cada dos meses', 3: 'cada tres meses', 6: 'cada seis meses' };

  var cartTotal = 0;
  var instances = [];

  /* ---------- Utilidades ---------- */
  // Formato del diseño: 14,00€ (la moneda de la tienda da "14.00€")
  function money(cents) {
    return (Math.round(cents) / 100).toFixed(2).replace('.', ',') + '€';
  }

  // "5,00€" -> "5€" para textos cortos
  function moneyShort(cents) {
    return money(cents).replace(/[.,]00(?=\D*$)/, '');
  }

  function gramsFrom(text) {
    var m = /(\d+(?:[.,]\d+)?)\s*(kg|g)/i.exec(text || '');
    if (!m) return 0;
    var n = parseFloat(m[1].replace(',', '.'));
    return m[2].toLowerCase() === 'kg' ? n * 1000 : n;
  }

  function cafesFrom(grams) {
    return Math.round((grams * CAFES_PER_500G) / 500);
  }

  function weightLabel(grams) {
    if (grams >= 1000) {
      return String(Math.round((grams / 1000) * 100) / 100).replace('.', ',') + ' kg';
    }
    return grams + 'g';
  }

  function formatNumber(n) {
    return String(Math.round(n * 10) / 10).replace('.', ',');
  }

  // Cafés al día que salen en un mes (30 días): "2 cafés al día durante un mes"
  function perDayInMonth(cafes) {
    var perDay = cafes / 30;
    var label = formatNumber(perDay);
    return label + (label === '1' ? ' café' : ' cafés') + ' al día durante un mes';
  }

  function threshold() {
    var t = window.theme && window.theme.freeShippingThreshold;
    return typeof t === 'number' && t > 0 ? t : 4000;
  }

  function shippingCost() {
    var c = window.theme && window.theme.shippingCost;
    return typeof c === 'number' ? c : 500;
  }

  /* ---------- Carrito (total actual para "te faltan X €") ---------- */
  function setCartTotal(cart) {
    if (!cart || typeof cart.total_price !== 'number') return;
    cartTotal = cart.total_price;
    instances.forEach(function (inst) { inst.update(); });
  }

  function fetchCart() {
    var root = (window.theme && window.theme.routes && window.theme.routes.cartUrl) || '/cart';
    fetch(root + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(setCartTotal)
      .catch(function () {});
  }

  function bindCartEvents() {
    if (bindCartEvents.done) return;
    bindCartEvents.done = true;
    if (window.jQuery) {
      window.jQuery(document.body).on('afterCartLoad.ajaxCart afterGetCart.ajaxCart', function (evt, cart) {
        setCartTotal(cart);
      });
      window.jQuery(document.body).on('afterAddItem.ajaxCart afterChangeItem.ajaxCart', fetchCart);
    }
    document.addEventListener('cart:updated', fetchCart);
    fetchCart();
  }

  /* ---------- Instancia ---------- */
  function FeaturedProduct(root) {
    this.root = root;
    this.form = root.querySelector('[data-lfp-form]');
    this.data = { variants: [], labels: {} };

    var json = root.querySelector('[data-lfp-json]');
    if (json) {
      try { this.data = JSON.parse(json.textContent); } catch (e) { /* JSON inválido */ }
    }

    this.qty = 1;
    this.mode = root.getAttribute('data-mode') || 'onetime';

    this.bindMore();
    if (this.form) {
      this.bindToggle();
      this.bindOptions();
      this.bindQty();
      this.bindCta();
      this.update();
    }
    this.observe();
  }

  FeaturedProduct.prototype.$ = function (sel) { return this.root.querySelector(sel); };
  FeaturedProduct.prototype.$$ = function (sel) { return Array.prototype.slice.call(this.root.querySelectorAll(sel)); };

  /* "Saber más": + rota a × y despliega la lista */
  FeaturedProduct.prototype.bindMore = function () {
    var btn = this.$('[data-lfp-more]');
    if (!btn) return;
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') !== 'true';
      btn.setAttribute('aria-expanded', String(open));
      panel.classList.toggle('is-open', open);
      panel.setAttribute('aria-hidden', String(!open));
      if (open) { panel.removeAttribute('inert'); } else { panel.setAttribute('inert', ''); }
    });
  };

  FeaturedProduct.prototype.bindToggle = function () {
    var self = this;
    var thumb = this.$('.lfp-toggle__thumb');
    this.$$('[data-lfp-mode]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var mode = btn.getAttribute('data-lfp-mode');
        if (mode === self.mode) return;
        self.mode = mode;
        if (thumb) {
          thumb.classList.remove('is-moving');
          void thumb.offsetWidth; // reinicia la animación
          thumb.classList.add('is-moving');
        }
        self.update();
      });
      btn.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        var next = self.$('[data-lfp-mode]:not([aria-checked="true"])');
        if (next) { next.click(); next.focus(); }
      });
    });
  };

  FeaturedProduct.prototype.bindOptions = function () {
    var self = this;
    this.$$('[data-lfp-option], [data-lfp-plan]').forEach(function (input) {
      input.addEventListener('change', function () { self.update(); });
    });
  };

  FeaturedProduct.prototype.bindQty = function () {
    var self = this;
    this.$$('[data-lfp-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var delta = parseInt(btn.getAttribute('data-lfp-step'), 10) || 0;
        self.qty = Math.max(1, Math.min(99, self.qty + delta));
        self.update();
      });
    });
  };

  /* Añadir al carrito (AJAX) y abrir el carrito lateral */
  FeaturedProduct.prototype.bindCta = function () {
    var self = this;
    var cta = this.$('[data-lfp-cta]');
    if (!cta) return;
    cta.addEventListener('click', function () {
      if (cta.disabled || cta.classList.contains('is-loading') || !self.payload) return;
      self.showError('');
      cta.classList.add('is-loading');

      var routes = (window.theme && window.theme.routes) || {};
      fetch((routes.cartAddUrl || '/cart/add') + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [self.payload] })
      })
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok) throw new Error(data.description || data.message || 'Error');
            return data;
          });
        })
        .then(function () {
          cta.classList.remove('is-loading');
          self.openCart();
        })
        .catch(function (err) {
          cta.classList.remove('is-loading');
          self.showError(err.message);
        });
    });
  };

  FeaturedProduct.prototype.openCart = function () {
    if (window.EbocaCartDrawer && window.EbocaCartDrawer.el) {
      window.EbocaCartDrawer.open();
      document.dispatchEvent(new CustomEvent('cart:updated'));
      return;
    }
    var $ = window.jQuery;
    if ($ && window.ajaxCart && typeof window.ajaxCart.load === 'function' && window.theme && window.theme.cart_ajax) {
      $(document.body).one('afterCartLoad.ajaxCart', function () {
        if (typeof window.theme.mfpOpen === 'function') window.theme.mfpOpen('cart');
      });
      window.ajaxCart.load();
    } else {
      window.location.href = (window.theme && window.theme.routes && window.theme.routes.cartUrl) || '/cart';
    }
    document.dispatchEvent(new CustomEvent('cart:updated'));
  };

  FeaturedProduct.prototype.showError = function (message) {
    var el = this.$('[data-lfp-error]');
    if (!el) return;
    el.textContent = message || '';
    el.hidden = !message;
  };

  FeaturedProduct.prototype.selectedOptions = function () {
    var selected = [];
    this.$$('[data-lfp-option]:checked').forEach(function (input) {
      selected[parseInt(input.getAttribute('data-lfp-option'), 10)] = input.value;
    });
    return selected;
  };

  FeaturedProduct.prototype.currentVariant = function () {
    var variants = this.data.variants || [];
    if (variants.length === 1) return variants[0];
    var selected = this.selectedOptions();
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var match = v.options.every(function (opt, idx) {
        return selected[idx] === undefined || selected[idx] === opt;
      });
      if (match) return v;
    }
    return variants[0];
  };

  FeaturedProduct.prototype.currentPlan = function () {
    var input = this.$('[data-lfp-plan]:checked');
    if (!input) return null;
    return { id: input.value, months: parseInt(input.getAttribute('data-months'), 10) || 1 };
  };

  // Marca las opciones agotadas en combinación con la selección actual
  FeaturedProduct.prototype.markAvailability = function () {
    var variants = this.data.variants || [];
    var selected = this.selectedOptions();
    this.$$('[data-lfp-option]').forEach(function (input) {
      var idx = parseInt(input.getAttribute('data-lfp-option'), 10);
      var available = variants.some(function (v) {
        if (!v.available || v.options[idx] !== input.value) return false;
        return v.options.every(function (opt, j) {
          return j === idx || selected[j] === undefined || selected[j] === opt;
        });
      });
      input.closest('.lfp-choice').classList.toggle('is-unavailable', !available);
    });
  };

  FeaturedProduct.prototype.update = function () {
    if (!this.form) return;

    var labels = this.data.labels || {};
    var variant = this.currentVariant();
    if (!variant) return;

    var isSub = this.mode === 'subscription';
    var plan = isSub ? this.currentPlan() : null;
    if (isSub && !plan) { isSub = false; }

    this.root.setAttribute('data-mode', isSub ? 'subscription' : 'onetime');

    /* Toggle + bloque de suscripción */
    this.$$('[data-lfp-mode]').forEach(function (btn) {
      btn.setAttribute('aria-checked', String(btn.getAttribute('data-lfp-mode') === (isSub ? 'subscription' : 'onetime')));
    });
    var subBlock = this.$('[data-lfp-sub]');
    if (subBlock) {
      if (isSub) { subBlock.removeAttribute('inert'); } else { subBlock.setAttribute('inert', ''); }
      subBlock.setAttribute('aria-hidden', String(!isSub));
    }

    /* Estado visual de las tarjetas */
    this.$$('.lfp-choice__input').forEach(function (input) {
      input.closest('.lfp-choice').classList.toggle('is-selected', input.checked);
    });
    this.markAvailability();

    /* Precios */
    var qty = this.qty;
    var unitPrice = variant.price;
    if (isSub && variant.plans && variant.plans[plan.id] !== undefined) {
      unitPrice = variant.plans[plan.id];
    }
    var total = unitPrice * qty;
    var compareTotal = variant.price * qty;

    /* Cafés (500 g = 60 cafés) */
    var gramsPerBag = gramsFrom(variant.options.join(' ')) || gramsFrom(variant.title) || 500;
    var totalGrams = gramsPerBag * qty;
    var totalCafes = cafesFrom(totalGrams);

    /* Envío gratis: umbral global - (carrito actual + selección) */
    var limit = threshold();
    var reached = cartTotal + total;
    var remaining = Math.max(0, limit - reached);
    var isFree = remaining === 0;

    /* Línea que se añadirá al carrito */
    this.payload = { id: variant.id, quantity: qty };
    if (isSub) this.payload.selling_plan = parseInt(plan.id, 10);

    /* Cantidad */
    // Puede haber más de un selector de cantidad (p. ej. tarjetas: compra única y suscripción)
    var bagWord = qty === 1 ? 'bolsa' : 'bolsas';
    var qtyTitleText = (NUMBERS[qty] || qty) + ' ' + bagWord + ' (' + weightLabel(totalGrams) + ')';
    this.$$('[data-lfp-qty-title]').forEach(function (el) { el.textContent = qtyTitleText; });
    this.$$('[data-lfp-qty-note]').forEach(function (el) { el.textContent = totalCafes + ' cafés'; });
    this.$$('[data-lfp-qty-value]').forEach(function (el) { el.textContent = qty; });
    this.$$('[data-lfp-step="-1"]').forEach(function (el) { el.disabled = qty <= 1; });

    /* Barra de envío gratis */
    var ship = this.$('[data-lfp-ship]');
    if (ship) {
      var pct = Math.min(100, (reached / limit) * 100);
      ship.classList.toggle('is-free', isFree);
      this.$('[data-lfp-ship-fill]').style.width = pct + '%';
      this.$('[data-lfp-ship-label]').innerHTML = isFree
        ? '¡Tu pedido tiene envío gratis!'
        : 'Te faltan <strong>' + money(remaining) + '</strong> para envío gratis';
    }

    /* Notas de frecuencia: coste de envío */
    var shipText = isFree ? 'Envío gratis' : 'Envío ' + moneyShort(shippingCost());
    this.$$('[data-lfp-plan-note]').forEach(function (el) { el.textContent = shipText; });

    /* Resumen: suscripción → ritmo de consumo; compra única → cuánto dura */
    var summary = this.$('[data-lfp-summary]');
    if (summary) {
      var shipSummary = isFree ? 'envío gratis' : 'envío ' + moneyShort(shippingCost());
      if (plan) {
        var days = plan.months * 30;
        var perDay = totalCafes / days;
        var cadence;
        if (perDay >= 1) {
          cadence = formatNumber(perDay) + (Math.round(perDay * 10) === 10 ? ' café' : ' cafés') + ' al día';
        } else {
          cadence = '1 café cada ' + Math.round(days / totalCafes) + ' días';
        }
        summary.textContent = cadence + ' ' + (MONTHS_TEXT[plan.months] || 'cada ' + plan.months + ' meses') + ', ' + shipSummary;
      } else {
        summary.textContent = perDayInMonth(totalCafes) + ' (' + totalCafes + ' cafés), ' + shipSummary;
      }
    }

    /* Precio */
    var priceEl = this.$('[data-lfp-price]');
    if (priceEl) priceEl.textContent = money(total);
    var compareEl = this.$('[data-lfp-compare]');
    if (compareEl) {
      var showCompare = isSub && compareTotal > total;
      compareEl.hidden = !showCompare;
      compareEl.textContent = showCompare ? money(compareTotal) : '';
    }
    var cafesEl = this.$('[data-lfp-cafes]');
    if (cafesEl) cafesEl.textContent = totalCafes + ' cafés';

    /* Botón */
    var cta = this.$('[data-lfp-cta]');
    var ctaText = this.$('[data-lfp-cta-text]');
    if (cta && ctaText) {
      cta.disabled = !variant.available;
      if (!variant.available) {
        ctaText.textContent = labels.soldOut || 'Agotado';
      } else if (isSub) {
        var per = plan.months === 1 ? '/mes' : ' cada ' + plan.months + ' meses';
        ctaText.textContent = (labels.ctaSub || 'Suscribirme') + ' · ' + money(total) + per;
      } else {
        ctaText.textContent = (labels.cta || 'Añadir a la bolsa') + ' · ' + money(total);
      }
    }
  };

  /* Aplica una configuración externa (p. ej. el test de café): suscripción,
     frecuencia en meses y nº de bolsas, con un destello en lo que cambia. */
  FeaturedProduct.prototype.applyConfig = function (cfg) {
    var self = this;
    var plans = this.$$('[data-lfp-plan]');
    if (plans.length) {
      var match = plans.filter(function (r) { return parseInt(r.getAttribute('data-months'), 10) === cfg.months; })[0] || plans[0];
      match.checked = true;
      if (this.mode !== 'subscription') {
        this.mode = 'subscription';
        var thumb = this.$('.lfp-toggle__thumb');
        if (thumb) { thumb.classList.remove('is-moving'); void thumb.offsetWidth; thumb.classList.add('is-moving'); }
      }
    }
    if (cfg.qty) this.qty = Math.max(1, Math.min(99, cfg.qty));
    this.update();

    this.root.classList.remove('is-applied');
    void this.root.offsetWidth;
    this.root.classList.add('is-applied');
    clearTimeout(this.appliedTimer);
    this.appliedTimer = setTimeout(function () { self.root.classList.remove('is-applied'); }, 2000);
  };

  /* Gramos por bolsa de la variante seleccionada (para el test de café) */
  FeaturedProduct.prototype.gramsPerBag = function () {
    var v = this.currentVariant();
    if (!v) return 500;
    return gramsFrom(v.options.join(' ')) || gramsFrom(v.title) || 500;
  };

  /* Animación de entrada al hacer scroll */
  FeaturedProduct.prototype.observe = function () {
    var root = this.root;
    if (!('IntersectionObserver' in window) || window.Shopify && window.Shopify.designMode) {
      root.classList.add('is-inview');
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          root.classList.add('is-inview');
          io.disconnect();
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });
    io.observe(root);
  };

  /* ---------- Init ---------- */
  function init(scope) {
    (scope || document).querySelectorAll('[data-lfp]').forEach(function (root) {
      if (root.__lfp) return;
      root.__lfp = new FeaturedProduct(root);
      instances.push(root.__lfp);
    });
    bindCartEvents();
  }

  window.EbocaPurchase = { init: init, money: money, cafesFrom: cafesFrom, CAFES_PER_500G: CAFES_PER_500G };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    instances = instances.filter(function (inst) { return document.body.contains(inst.root); });
    init(e.target);
  });
})();
